import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { SEMI_FRESH } from '../../lib/queryPresets';
import {
  listEmailTemplates, createEmailTemplate, updateEmailTemplate,
  type EmailTemplate,
} from '../../services/documents/emailTemplateService';

export const emailTemplateKeys = {
  all: ['email-templates'] as const,
  list: (activeOnly: boolean) => [...emailTemplateKeys.all, activeOnly] as const,
};

export function useEmailTemplates(activeOnly: boolean) {
  return useQuery({
    ...SEMI_FRESH,
    queryKey: emailTemplateKeys.list(activeOnly),
    queryFn: () => listEmailTemplates(activeOnly),
  });
}

export function useCreateEmailTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: Parameters<typeof createEmailTemplate>[0]) => createEmailTemplate(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: emailTemplateKeys.all }),
  });
}

export function useUpdateEmailTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch }: { id: string; patch: Partial<EmailTemplate> }) =>
      updateEmailTemplate(id, patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: emailTemplateKeys.all }),
  });
}
